import axios from "axios";
import { base_url } from "../../utils/baseUrl";
import { config } from "../../utils/axiosconfig";

const getTvPrograms = async () => {
  const response = await axios.get(`${base_url}radioprogram/getTvPrograms`);
 
  return response.data;
  
};
const createTvPrograms = async (formData) => {
  const response = await axios.post(`${base_url}radioprogram/register`, formData);

  return response.data;
};
const updateTvProgram = async (News) => {
  const formData = new FormData();
  formData.append("name", News.NewsData.get("name"));
  formData.append("time", News.NewsData.get("time"));
  formData.append("image", News.NewsData.get("image"));

  const response = await axios.put(
    `${base_url}radioprogram/edittvProgram/${News.id}`,
    formData,
    config
  );

  return response.data;
};

const getTvProgram = async (id) => {
  const response = await axios.get(`${base_url}radioprogram/getById/${id}`, config);

  return response.data;
};

const deleteTvProgram = async (id) => {
  const response = await axios.delete(`${base_url}radioprogram/deletetvProgram/${id}`, config);

  return response.data;
};
const TvProgramService = {
  getTvPrograms,
  createTvPrograms,
  getTvProgram,
  updateTvProgram,
  deleteTvProgram,
};

export default TvProgramService;
